import {useQuery} from "@tanstack/react-query";
import React from "react";
import {readVatSelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";


const useReadVatSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readVatSelectBox"],
        queryFn: async () => await readVatSelectBoxApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
    });
    return {data};
};

export default useReadVatSelectBox;
